import classNames from 'classnames';
import { ButtonHTMLAttributes } from 'react';
import { NAVIGATION_KEYS } from 'src/interfaces/enums';
import { stopKeyDownPropagation } from 'src/utils/browserUtils';
import styles from './styles.module.scss';

export interface IIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactElement;
}

const IconButton = ({ icon, className = '', ...buttonProps }: IIconButtonProps) => {
  return (
    <button
      onKeyDown={(event) => stopKeyDownPropagation(event, { keys: [NAVIGATION_KEYS.SPACE] })}
      className={classNames(styles.iconButton, className)}
      {...buttonProps}
    >
      {icon}
    </button>
  );
};

export default IconButton;
